<template>
  <div class="warp_contrainer">
    <div class="search_container">
      <!-- <el-tabs v-model="activeName" type="card" @tab-click="handleClick(activeName)">
              <el-tab-pane label="所有" name="1"> </el-tab-pane>
              <el-tab-pane label="已预约" name="2"></el-tab-pane>
              <el-tab-pane label="已过期" name="3"></el-tab-pane>
        </el-tabs> -->
      <div class="navCalss">| 预约订单</div>
      <!-- 订单查询 -->
      <div class="search">
        <span
          >发货单号:
          <el-input
            placeholder="输入发货单号"
            clearable
            v-model="orderNo"
            @clear="cancelSearch"
          ></el-input
        ></span>
        <span
          >用户名/ViP号:
          <el-input
            placeholder="输入用户名/vip号查询"
            clearable
            v-model="userName"
            @clear="cancelSearch"
          ></el-input>
        </span>
        <span
          >批次:

          <el-select
           style="width:255px"
            v-model="batchNum"
            remote
            @change="batchChange"
            @clear="clearChecked"
            :remote-method="remoteMethod"
            reserve-keyword
            filterable
            :loading="loading"
            clearable
            placeholder="请输入批次"
          >
            <el-option
              v-for="item in batchList"
              :key="item.sendId"
              :label="item.remark"
              :value="item.remark"
            >
            </el-option>
          </el-select>
        </span>

        <span
          >货物类型:
          <el-select
            v-model="search.goodType"
            clearable
            placeholder="货物类型"
            @change="init()"
            @clear="cancelSearch"
            style="width: 150px"
          >
            <el-option
              v-for="item in goodTypeSelect"
              :key="item.goodType"
              :label="item.goodName"
              :value="item.goodType"
            >
            </el-option>
          </el-select>
        </span>

        <span>签收状态：</span>
        <el-select v-model="checkedRecStatus" 
        clearable
        @change="getAppointList('1')"
        placeholder="请选择" style="width:120px">
    <el-option
      v-for="item in receOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>

  <span>派送点：</span>
        <el-select
                  v-model="deliverAddress"
                  style="width: 160px"
                  clearable
                  :disabled="roleId==3"
                >
                  <el-option label="所有" value=""></el-option>
                  <el-option
                    v-for="(addressObj, aIndex) in deliverAddressArr"
                    :key="aIndex"
                    :label="addressObj.deliveryTitle"
                    :value="addressObj.adminId"
                  ></el-option>
                </el-select>

        <span>
          <el-button
            type="primary"
            style="margin-left: 12px"
            @click="getAppointList('select')"
            >查 询</el-button
          >
        </span>
      </div>
      <!-- 表格区域 -->
      <div class="table">
        <el-table
          :data="mainList"
          border
          max-height="700px"
          ref="filterTable"
          @selection-change="handleSelectionChange"
          style="width: 100%"
        >
          <el-table-column type="selection" width="35" align="center">
          </el-table-column>
          <el-table-column label="运单" align="center">
            <template slot-scope="scope">
              <span> {{ scope.row.orderCount }} 个运单 </span>
            </template>
          </el-table-column>
          <el-table-column prop="realName" label="客户" align="center">
          </el-table-column>
          <el-table-column prop="vipCode" label="vip号" align="center">
          </el-table-column>
          <el-table-column prop="goodType" label="货物类型" align="center">
            <template slot-scope="scope">
              <span>
                <span class="tag" v-if="scope.row.goodType == 1">{{
                  goodTypeName(scope.row.goodType)
                }}</span>
                <span class="tag tag3" v-if="scope.row.goodType == 2">{{
                  goodTypeName(scope.row.goodType)
                }}</span>
                <span class="tag tag1" v-if="scope.row.goodType == 3">{{
                  goodTypeName(scope.row.goodType)
                }}</span>
                {{ scope.row.goodName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sendNo"
            label="发货单号"
            width="160px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="批次"
            prop="sendRemark"
            min-width="180px"
            align="center"
          >
          </el-table-column>
          <el-table-column
          label="箱号"
          prop="boxNumber"
          min-width="180px"
          align="center"
        >
        </el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.sendStatus == 4" style="color: red">
                已结算
              </div>
              <div
                v-else-if="scope.row.sendStatus == 10"
                style="color: #008b8b"
              >
                可预约
              </div>
              <div
                v-else-if="scope.row.sendStatus == 11"
                style="color: #800080"
              >
                已预约
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="总费用" align="center">
            <template slot-scope="scope">
              <span>
                {{
                  (text =
                    scope.row.sendNo == null
                      ? scope.row.total
                      : scope.row.amount)
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="7"
            label="预约时间"
            align="center"
            width="100px"
          >
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.appointmentTime
                    ? changeDateCopy(scope.row.appointmentTime, 3)
                    : "无时间数据"
                }}
              </span>

              <el-tag type="success" style="min-width: 80px">
                {{
                  scope.row.start && scope.row.endTime
                    ? itemChangedHM(scope.row.start, scope.row.endTime)
                    : "无预约时间"
                }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="派送点" align="center" prop="address">
          </el-table-column>
          <el-table-column
            label="签收状态"
            prop="isReceipt"
            min-width="90px"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.isReceipt ? "已签收" : "未签收" }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                class="bt"
                @click="showAccountDia(scope.row)"
                type="text"
                v-if="scope.row.sendStatus == 10 || scope.row.sendStatus == 11"
                >出库结算</el-button
              >
              <el-button class="bt2" @click="showOrder(scope.row)" type="text"
                >订单详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="float: right">
          <el-pagination
            :page-sizes="paginations.page_sizes"
            :page-size="paginations.page_size"
            :layout="paginations.layout"
            :total="paginations.total"
            :current-page="paginations.page_index"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 警告对话框 -->
    <!-- <el-dialog
  :visible.sync="warningDia"
  width="400px"
  :close-on-click-modal="false"
  :close-on-press-escape="false"
  :modal-append-to-body="false"
   center
  >
  <span class="warningText">
      你确定该订单已完成吗？此操作不可逆</span>
  <template #footer>
    <span class="warningDia-footer">
      <el-button type="primary" @click="showAccountDia">确 定</el-button>
      <el-button  @click="warningDia = false">取 消</el-button>
    </span>
  </template>
 </el-dialog> -->
    <br />
    <div>
      <el-button type="primary" size="small" @click="mulOutStoreToPay()"
        >批量出库结算</el-button
      >
    </div>

    <!-- 出库结算Dialog -->
    <el-dialog
      title="出库结算"
      :visible.sync="accountDia"
      width="60%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
    >
      <!-- 中间文字内容 -->
      <div v-for="(item, index) of accountList" :key="index" class="BigBox">
        <div class="accountDia-content-header">
          <div class="content-left content-left-text">
            <div>
              发货单号:
              <span>
                {{ item.sendNo }}
              </span>
            </div>
            <div>
              预约状态:
              <span style="color: rgb(9, 157, 255)"> 已预约 </span>
            </div>
          </div>
          <div class="content-center content-left-text">
            <div>
              VIP号:
              <span>
                {{ item.user.vipCode }}
              </span>
            </div>
            <div>
              入库时间:
              <span>
                {{
                  item.operatorTime
                    ? changeDate(item.operatorTime, 4)
                    : "无法显示"
                }}
              </span>
            </div>
          </div>
          <div class="content-right content-left-text">
            <div>
              客户:
              <span>
                {{ item.user.realName }}
              </span>
            </div>
            <div>
              订单数量: <span>{{ item.orderPojoList.length }}</span>
            </div>
          </div>
        </div>
        <div class="accountDia-content-center1" style="margin-bottom: 10px">
          所需总运费：<span>{{ item.totalFreight }}</span>
        </div>
        <div class="accountDia-content-center2" style="margin-bottom: 10px">
          所需总工单费用：<span>{{ item.totalWorkOrderFee }}</span>
        </div>
        <div class="accountDia-content-center2" style="margin-bottom: 10px">
          额外费用：<span>{{ item.extraPrice }}</span>
        </div>
        <div
          class="accountDia-content-footer1"
          style="width: 100%; overflow: hidden"
        >
          <div
            class="content-footer-left"
            style="width: 36%; float: left; margin-right: 20px"
          >
            最后总费用：<span>{{ item.totalCost }}</span> CAD
          </div>
          <div class="content-footer-right" style="width: 36%; float: left">
            账户余额：
            <span style="color: #d2691e">{{ item.user.balance }}</span> CAD
          </div>
        </div>
        <div
          class="accountDia-content-footer2"
          style="width: 100%; margin-top: 30px; text-align: center"
        >
          <span style="width: 46%; font-size: 17px; font-weight: bolder">
            订单列表
          </span>
        </div>
        <hr style="margin: 25px 0 -20px 0" />
        <div class="table">
          <el-table :data="listRow" style="width: 100%">
            <el-table-column type="index" label="#" align="center">
            </el-table-column>
            <el-table-column prop="productName" align="center" label="物品">
            </el-table-column>
            <el-table-column prop="orderNo" label="运单号" align="center">
            </el-table-column>
            <el-table-column prop="productNum" align="center" label="数量">
            </el-table-column>
            <el-table-column align="center" label="货运类型">
              <template slot-scope="scope">
                {{ goodTypeName(scope.row.goodType) }}
              </template>
            </el-table-column>
            <el-table-column prop="goodType" align="center" label="用户">
              <div>
                {{ accountList[0].user.realName }}
              </div>
            </el-table-column>
            <el-table-column prop="total" align="center" label="运费（CAD）">
            </el-table-column>
            <el-table-column
              prop="demandMoney"
              align="center"
              label="工费（CAD）"
            >
            </el-table-column>
          </el-table>
        </div>
        <!-- 按钮区域 -->
        <div class="accountDia-footer">
          <el-button type="primary" @click="settlementBt">确认结算</el-button>
          <el-button type="info" @click="accountDia = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 查看订单详情Dialog -->
    <el-dialog
      :visible.sync="listDia"
      width="70%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      center
    >
      <div class="diaText">
        <div class="e_text">发货单号：{{ orderMsg.sendNo }}</div>
        <div class="e_text">订单数量：{{ orderMsg.orderCount }}</div>
        <div class="e_text">相关用户VIP：{{ user.vipCode }}</div>
      </div>
      <div>
        <el-table :data="orderList" max-height="300px" style="width: 100%">
          <el-table-column
            prop="productName"
            label="名称"
            align="center"
            width="140"
          >
          </el-table-column>
          <el-table-column align="center" label="货物类型" width="140">
            <template slot-scope="scope">
              {{ goodTypeName(scope.row.goodType) }}
            </template>
          </el-table-column>
          <el-table-column label="客户" align="center" width="120">
            {{ user.realName }}
          </el-table-column>
          <el-table-column label="vip号" align="center" width="120">
            {{ user.vipCode }}
          </el-table-column>
          <el-table-column
            prop="expressNo"
            label="运单号"
            align="center"
            width="170"
          >
          </el-table-column>
          <el-table-column
            prop="predictTotal"
            label="商品价格"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column label="状态" align="center" width="120">
            <span style="color: rgb(9, 157, 255)"> 已预约 </span>
          </el-table-column>
          <el-table-column label="派送点" align="center" width="180">
            {{ user.deliveryTitle }}
          </el-table-column>
          <el-table-column
            prop="total"
            label="运费(CAD)"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="date"
            label="下单时间"
            align="center"
            width="240px"
          >
            <template slot-scope="scope">
              {{ changeDate(scope.row.storeTime, 4) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <template #footer>
        <span class="warningDia-footer">
          <el-button type="primary" @click="listDia = false">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>


<script>
import * as book from "../../api/book";
import * as mUtils from "../../utils/mUtils";
import * as order from "@/api/order";
export default {
  data() {
    return {
      activeName: "1",
      orderNo: "",
      userName: "",
      batchNum: "",
      bookText: "",
      accountDia: false,
      warningDia: false,
      listDia: false,
      orderMsg: [],
      user: [],
      overdueList: [],
      overdueDlist: [],
      accountList: [],
      mainList: [],
      orderList: [],
      listRow: [],
      sendId: "",
      status: "",
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        page_sizes: [5, 10, 20, 50], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      search: {
        goodType: null,
      },
      goodTypeSelect: [
        {
          goodType: 1,
          goodName: "海运",
        },
        {
          goodType: 2,
          goodName: "海运大件",
        },
        {
          goodType: 3,
          goodName: "空运",
        },
      ],
      isChina: null,
      multipleSelection: [],
      // 批次列表
      batchList: [],
      // 批次的时间 节流
      timeout: null,
      // 已选签收状态
      checkedRecStatus:null,
      // 签收状态选项
      receOptions:[
        {value:"0",label:"未签收"},
        {value:"1",label:"已签收"}
      ],
      loading:false,
      // 派送点
      deliverAddress: null,
      deliverAddressArr: [],
      // 表示当前登录账号类型
      roleId:null,
    };
  },
  created() {
    this.getAppointList();
    this.judgeIsChina();
    this.getBatchList();
    this.getAdressId();
  },
  mounted(){
    let userinfo=mUtils.getStore('userinfo');
    
    if(userinfo.roleId == 3){
      this.roleId = 3;
      this.deliverAddress = userinfo.adminId;
    }
  },
  methods: {
    init(index) {
      return index + 2;
    },
    // 将时间戳转换为正常时间格式
    changeDate(date, type) {
      return mUtils.formatDate(new Date(date), type);
    },

    // 将时间戳转换为正常时间格式(包含时区处理)
    changeDateCopy(date, type) {
      if (!this.isChina) {
        date += 86400000;
      }
      return mUtils.formatDate(new Date(date), type);
    },

    // 将具体时间段的时间戳转换为正常时间格式
    itemChangedHM(one, two) {
      let start = null;
      let end = null;
      if (!this.isChina) {
        start = this.changeToTimeCopy(one);
        end = this.changeToTimeCopy(two);
      } else {
        start = this.changeToTime(one);
        end = this.changeToTime(two);
      }
      return start + "-" + end;
    },
    changeToTime(datetimes) {
      let date = new Date(datetimes);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D = date.getDate() + " ";
      let h =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours() + ":";
      let m =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let s = date.getSeconds();

      var str = h + m;
      if (str.toString().length === 4) {
        str = h + ":" + m;
      }

      return str;
    },
    // 涉及时区的时间处理
    changeToTimeCopy(datetimes) {
      let that = this;
      let date = new Date(datetimes);
      let isChinaStr = date.toString();
      let result = isChinaStr.indexOf("+") != -1;

      let dateStr = date.toString();
      let arr = dateStr.split("GMT");
      const twoNum = arr[1].substring(1, 3);
      let howMany = 0;
      if (twoNum[0] == 0) {
        howMany = twoNum[1];
      } else {
        howMany = twoNum;
      }
      // that.howmany = howMany;
      if (!result) {
        let newDatetimes = (datetimes += (8 + howMany) * 3600 * 1000);
        date = new Date(newDatetimes);
      }

      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D = date.getDate() + " ";
      let h =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours() + ":";
      let m =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let s = date.getSeconds();

      var str = h + m;
      if (str.toString().length === 4) {
        str = h + ":" + m;
      }

      return str;
    },

    // spanClass
    spanC(status) {
      this.bookText = status == 1 ? "bookTextN" : "bookTextP";
    },
    // handleClick(res){
    //   this.mainList=[]
    //   if(res=='1')
    //    this.mainList=this.bookData
    //    else if(res=='2'){
    //    this.mainList=this.overdueDlist
    //    }
    //    else if(res=='3'){
    //    this.mainList=this.overdueList
    //    }
    // },
    // 获取已预约订单列表
    getAppointList(type) {
      let that = this;
      let param = {
        // number:this.orderNo,
        sendNo: this.orderNo,
        userName: this.userName,
        batchNumber: that.batchNum ? this.batchNum.trim() : "",
        goodType: this.search.goodType,
        pageIndex: this.paginations.page_index,
        pageSize: this.paginations.page_size,
        isReceipt:that.checkedRecStatus || null,
        deliveryId:null,
      };

      // 如果选择了派送点或者已有派送点
      if(that.deliverAddress){
        that.deliverAddressArr.forEach((dItem,index)=>{
          if(dItem.adminId == that.deliverAddress){
            param.deliveryId = dItem.addressId;
          }
        })
      }

      this.mainList = [];
      if (type) {
        param.pageIndex = 1;
        this.paginations.page_index = 1;
      }
      // this.overdueList=[]
      // this.overdueDlist=[]
      book.getAppointList(param).then((res) => {
        if (res.status == 200) {
          this.mainList = res.data.data.list;
          this.paginations.total = res.data.data.pageCount;

          // this. deliverData()
        }
      });
      // this.mainList=this.bookData2
    },
    // 将已预约和其他状态的数据分开
    // deliverData(){
    //   this.overdueDlist=[]
    //   if(this.mainList==undefined)
    //   return
    //   for(var i=0;i<this.mainList.length;i++){
    //     if(this.mainList[i].sendStatus==11){
    //       this.overdueDlist[this.overdueDlist.length]=this.mainList[i]
    //     }else{
    //       this.overdueList[this.overdueList.length]=this.mainList[i]
    //     }
    //   }
    //   this.mainList=this.overdueDlist
    // },
    settlementBt() {
      // if (
      //   this.accountList[0].user.balance -
      //     0 -
      //     (this.accountList[0].totalCost - 0) >=
      //   0
      // ) {
      //   this.confirmSettlement();
      // } else if (
      //   this.accountList[0].user.balance -
      //     0 -
      //     (this.accountList[0].totalCost - 0) <
      //   0
      // ) {
      //   this.$message.error("用户余额不足，无法出库结算,请提醒用户及时充值！");
      // }
      this.confirmSettlement();
      this.accountDia = false;
    },
    confirmSettlement() {
      let param = {
        sendId: this.sendId,
        balanceRemark: "预约自提结算",
      };
      book.confirmSettlement(param).then((res) => {
        if (res.status !== 200)
          return this.$message.error("出库结算失败: " + res.msg);
        if (res.data.code !== 0) {
          return this.$message.error("出库结算失败: " + res.data.msg);
        }
        this.getAppointList();
        this.$message.success("出库结算成功");
      });
    },
    cancelSearch() {
      this.getAppointList();
    },
    // 返回货物类型字符串
    goodTypeName(goodType) {
      let str = "";
      switch (goodType) {
        case 1:
          str = "海运";
          break;
        case 2:
          str = "海运大件";
          break;
        case 3:
          str = "空运";
          break;
      }
      return str;
    },
    // showWarningDia(row){
    //   this.showAccountDia()
    //   this.sendId=row.sendId
    //   this.status=row.status
    // },

    // 让结算对话框显示出来
    showAccountDia(row) {
      this.status = row.status;
      this.sendId = row.sendId;
      let param = {
        sendId: row.sendId,
      };
      book.getSettlementSheet(param).then((res) => {
        if (res.status == 200) {
          if (res.data.code !== 0) {
            this.$message.error("获取出库面单失败");
            return;
          } else if (res.data.data == {}) {
            return this.$message.error("获取出库面单失败: 无出库面单数据");
          }
          this.accountList[0] = res.data.data !== {} ? res.data.data : [];
          this.listRow = this.accountList[0].orderPojoList
            ? this.accountList[0].orderPojoList
            : [];
          // this.accountDia = true;
          this.settlementBt();
        }
      });
    },
    showOrder(row) {
      let param = {
        sendId: row.sendId,
      };
      book.getSettlementSheet(param).then((res) => {
        if (res.status == 200) {
          if (res.data.code !== 0) {
            this.$message.error("获取订单详情失败：" + res.data.msg);
            return;
          } else if (res.data.data == {}) {
            return this.$message.error("获取订单详情失败: 无出库面单数据");
          }
          this.orderMsg = res.data.data !== {} ? res.data.data : [];
          this.orderList = this.orderMsg.orderPojoList
            ? this.orderMsg.orderPojoList
            : [];
          this.user = this.orderMsg.user ? this.orderMsg.user : [];
          this.listDia = true;
        }
      });
    },
    // 页数获取
    handleSizeChange(page_size) {
      this.paginations.page_size = page_size;
      this.getAppointList();
    },
    // 上下分页
    handleCurrentChange(page) {
      this.paginations.page_index = page;
      this.getAppointList();
    },
    judgeIsChina() {
      var date = new Date();
      let isChinaStr = date.toString();
      let result = isChinaStr.indexOf("中国") != -1;
      this.isChina = result;
    },

    // 获取批次列表
    getBatchList(value) {
      let that = this;

      let data = {};

      value ? (data.batchNumber = value) : "";

      order.getSelectBatchList(data).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchList = res.data.data;
          } else {
            that.batchList = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },

    // 远程搜索批次
    remoteMethod(value) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getBatchList(value);
      }, 500);
    },

    // 清除所选批次
    clearChecked() {
      this.getBatchList();
      this.getAppointList();
    },

    batchChange() {
      this.getAppointList();
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    // 批量出库结算
    mulOutStoreToPay() {
      let that = this;
      if (
        that.multipleSelection == null ||
        that.multipleSelection.length == 0
      ) {
        this.$message.error("请选择");
        return;
      }
      let param = {};
      let sendIds = [];
      that.multipleSelection.forEach((value) => {
        sendIds.push(value.sendId);
      });
      param.sendIds = sendIds;
      param.balanceRemark = "预约自提结算";
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });

      book.mulOutStoreToPay(param).then((res) => {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "提交成功!",
          type: "success",
        });
        this.getAppointList();
      });
    },

            //获取派送点
    getAdressId() {
      let uselist = mUtils.getStore("userinfo");
      let realName = uselist.realName;
      let roleId = uselist.roleId;
      book.deliveryList({ type: 2 }).then((res) => {
        if (res.status !== 200) {
          return this.$message.error("获取用户失败：" + res.msg);
        }
        if (res.data.code !== 0) {
          return this.$message.error("获取错误：" + res.data.msg);
        }
        if (res.data.data && res.data.data.list) {
          this.deliverAddressArr = res.data.data.list;
        }
      });
    },

  },
};
</script>

<style lang="less" scoped>
.warp_contrainer {
  padding: 3px 20px 50px 20px;
  margin-bottom: 50px;
}
.bookTextN {
  color: rgb(9, 157, 255);
}
.bookTextP {
  color: rgb(255, 9, 62);
}
.navCalss {
  font-family: "PingFangSC-Semibold", "PingFang SC Semibold", "PingFang SC",
    sans-serif;
  font-weight: 650;
  font-size: 18px;
}
.search {
  margin-top: 30px;
  font-size: 18px;
  min-width: 1000px;
  span {
    display: inline-block;
    margin-top: 10px;
    margin-left: 20px;
  }
}
.status_text {
  div {
    font-size: 16px;
  }
}
.tag {
  display: inline-block;
  padding: 3px 5px;
  border-radius: 4px;
  background-color: #f4f4f5;
  border-color: #e9e9eb;
  color: #909399;
  &.tag1 {
    background-color: #ecf5ff;
    color: #409eff;
    border: 1px solid #d9ecff;
  }
  &.tag2 {
    background-color: #f0f9eb;
    border-color: #e1f3d8;
    color: #67c23a;
  }
  &.tag3 {
    background-color: #fdf6ec;
    border-color: #faecd8;
    color: #e6a23c;
  }
}
.el-input {
  width: 220px;
}
.el-table {
  margin-top: 40px;
}
.warningText {
  margin-left: 15px;
  font-size: 18px;
}
.accountDia-footer {
  width: 100%;
  margin: auto;
  margin-top: 25px;
  text-align: center;
  letter-spacing: 50px;
  .el-button {
    width: 150px;
  }
}
.accountDia-content-header {
  position: relative;
  margin-top: -20px;
  width: 100%;
  overflow: hidden;

  .content-left {
    width: 36%;
    float: left;
  }
  .content-center {
    width: 36%;
    float: left;
  }
  .content-right {
    position: absolute;
    top: 0;
    right: 0;
    width: 20%;
  }
  .content-left-text {
    div {
      margin-bottom: 25px;
    }
  }
  div {
    margin-right: 20px;
  }
}
.footer {
  width: 100%;
  margin: 20px 0 50px 0;
  position: relative;
  .footer_pagination {
    position: absolute;
    right: 0;
    top: 0;
    left: 200px;
    margin-top: 0;
    text-align: right;
  }
}
.BigBox {
  div {
    font-size: 16px;
  }
}
.accountShop {
  width: 100%;
  overflow: hidden;
  border-bottom: 2px solid rgb(204, 202, 202);
  margin-bottom: 5px;
}
.accountShop-box {
  height: 48px;
  div {
    float: left;
  }
  .layout {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
  .box-index {
    margin: 0 5px 0 50px;
    width: 5%;
    text-align: center;
  }
  .box-content {
    margin-right: 20px;
    width: 20.3%;
    position: relative;
    .box-content-top-out {
      width: 90%;
      .box-content-top {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        background-color: #00bfff;
        border-radius: 3px;
        color: #fff;
      }
    }
    .content-account {
      margin-right: 10px;
      width: 18%;
    }
    .content-warning {
      position: absolute;
      color: rgb(255, 39, 86);
      top: 15px;
      right: 35px;
    }
  }
  .box-transport {
    margin-right: 20px;
    width: 4.2%;
  }
  .box-realName {
    margin: 6px 30px 0 0;
    max-width: 40%;
    background-color: #ffd700;
    border-radius: 5px;
    padding: 5px;
  }
  .box-messages-left {
    margin-right: 15px;
    width: 16.5%;
  }
  .box-messages-right {
    width: 16.5%;
  }
}
.e_text {
  margin-bottom: 10px;
  font-size: 18px;
}
.diaText {
  div {
    display: inline-block;
    margin-left: 12.5%;
  }
}
</style>


// WEBPACK FOOTER //
// book.vue?6dbbf35e